// Importar configuración de producción
import PRODUCTION_CONFIG from '../config/production.js';

// Determinar la URL base de la API basada en el entorno
export const getApiBaseUrl = () => {
  return process.env.NODE_ENV === 'production' 
    ? PRODUCTION_CONFIG.API_BASE_URL 
    : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');
};

// Función para construir URLs de archivos
export const getFileUrl = (filePath) => {
  if (!filePath) return '';
  
  // Si la ruta ya incluye el dominio, devolverla tal como está
  if (filePath.startsWith('http')) {
    return filePath;
  }
  
  // Si la ruta no empieza con /, agregarla
  const cleanPath = filePath.startsWith('/') ? filePath : `/${filePath}`;
  
  // En producción, usar la URL base de producción
  if (process.env.NODE_ENV === 'production') {
    // Usar la URL base de producción para todos los archivos
    return `https://dashboard.doctorweb.top${cleanPath}`;
  } else {
    // En desarrollo, usar localhost
    return `http://localhost:3001${cleanPath}`;
  }
};

// Función para construir URLs de la API
export const getApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

// Función para hacer fetch con la URL correcta
export const apiFetch = async (endpoint, options = {}) => {
  const url = getApiUrl(endpoint);
  console.log(`🌐 API Request: ${url}`);
  
  // Verificar si el body es FormData para no incluir Content-Type
  const isFormData = options.body instanceof FormData;
  
  const defaultHeaders = isFormData 
    ? {} // No incluir Content-Type para FormData
    : { 'Content-Type': 'application/json' };
  
  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };
  
  // Eliminar Content-Type si es FormData para que el navegador establezca el boundary correcto
  if (isFormData && config.headers['Content-Type']) {
    delete config.headers['Content-Type'];
  }
  
  console.log(`📡 Tipo de datos: ${isFormData ? 'FormData' : 'JSON'}`);
  
  return fetch(url, config);
};

// Log de configuración
console.log('🔧 API Utils configurado:');
console.log('  - Entorno:', process.env.NODE_ENV);
console.log('  - URL base API:', getApiBaseUrl());
console.log('  - URL base archivos:', process.env.NODE_ENV === 'production' ? 'https://dashboard.doctorweb.top' : 'http://localhost:3001');
